export default __webpack_public_path__ + "static/media/dama.d35a9f01.PNG";